import { createRouter, createWebHistory } from "vue-router";
import createRoutes from "./createRoutes";

export default store => createRouter({
	history: createWebHistory(),
	routes: createRoutes(store)
});
